import { Component, OnInit } from '@angular/core';
import { NavigationService, ConfiguracionService } from '../../services';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss']
})
export class ConfiguracionComponent implements OnInit {
  public sendEmail: boolean = false;
  public hours: string = '1';
  public type: number = 1;  // 1: hours, 24: days, 168: weeks

  public max: number = 24;
  public min: number = 1;

  public neg_hours: string = '1';
  public neg_type: number = 1;  // 1: hours, 24: days, 168: weeks

  public neg_max: number = 24;

  constructor(
    private navigationService: NavigationService,
    private configService: ConfiguracionService) {

  }

  ngOnInit() {
    this.configService.getConfiguration().subscribe(r => {
      this.sendEmail = r.SentMail;
      this.hours = r.HoursBeforeNotification;
      this.type = Number(this.hours) >= 168 ? 168 : (Number(this.hours) >= 25 ? 24 : 1);
      this.max = this.type === 1 ? 24 : (this.type === 24 ? 30 : 16);

      this.neg_hours = r.HoursBeforeNotificationNegocio;
      this.neg_type = Number(this.neg_hours) >= 168 ? 168 : (Number(this.neg_hours) >= 25 ? 24 : 1);
      this.neg_max = this.neg_type === 1 ? 24 : (this.neg_type === 24 ? 30 : 16);
    });

  }

  toggleNav() {
    this.navigationService.toggleNav(true);
  }

  save() {
    // this.configService.setConfiguration(
    //   this.sendEmail,
    //   String(Number(this.hours) * this.type),
    //   String(Number(this.neg_hours) * this.neg_type))
    //     .subscribe(() => {});
  }

  updateMax(e) {
    this.max = e.value === 1 ? 24 : (e.value === 24 ? 30 : 16);
    this.save();
  }

  updateNegMax(e) {
    this.neg_max = e.value === 1 ? 24 : (e.value === 24 ? 30 : 16);
    this.save();
  }



}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/configuracion/configuracion.component.ts